module.exports = __webpack_public_path__ + "img/viber.94a3b2a5.jpg";